import Nav from "@/components/Nav";
import Seo from "@/components/Seo";
import WhatsAppBubble from "@/components/WhatsAppBubble";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Advantage from "@/components/Advantage";
import Faq from "@/components/Faq";
import RegisterForm from "@/components/RegisterForm";
import Footer from "@/components/Footer";

const Landing = () => (
  <div className="relative min-h-screen overflow-x-clip bg-night text-ink">
    <Seo />
    <WhatsAppBubble />
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Advantage />
      <Faq />
      <RegisterForm />
    </main>
    <Footer />
  </div>
);

export default Landing;
